export default __webpack_public_path__ + "static/media/icon-gear.002039f5.svg";